import { GQL } from '@aline/graphql';

import type { UUID } from '../../../types/type-helpers';
import type { AlineText, InputFieldElementInterface } from '../../internal';

export const signatureFieldVariant: GQL.FieldVariant.Signature = GQL.FieldVariant.Signature;

export interface SignatureFieldElement extends InputFieldElementInterface {
  children: AlineText[];
  variant: GQL.FieldVariant.Signature;
  imgHeightPx?: number | null;
  imgWidthPx?: number | null;
  signatureImgId?: UUID | null;
  /** Undefined on nodes created before initials existed; those are Signature. */
  signatureVariant?: GQL.SignatureFieldVariant | null;
}
export type SignatureFieldProps = Omit<SignatureFieldElement, 'children'>;

export function getSignatureFieldVariant(
  element: Pick<SignatureFieldElement, 'signatureVariant'>
): GQL.SignatureFieldVariant {
  return element.signatureVariant ?? GQL.SignatureFieldVariant.Signature;
}

/**
 * Reads a variant stored as untyped custom data (PDF widget or stamp). Widgets and
 * stamps created before initials existed carry nothing, so anything that isn't
 * Initials is a Signature.
 */
export function parseSignatureFieldVariant(raw: unknown): GQL.SignatureFieldVariant {
  return raw === GQL.SignatureFieldVariant.Initials
    ? GQL.SignatureFieldVariant.Initials
    : GQL.SignatureFieldVariant.Signature;
}

export function getIsInitialsSignatureField(
  element: Pick<SignatureFieldElement, 'signatureVariant'>
): boolean {
  return getSignatureFieldVariant(element) === GQL.SignatureFieldVariant.Initials;
}
